export default __webpack_public_path__ + "static/media/epfl-logo.720211dd.svg";